export default "__VITE_ASSET__Bq8vFT$h__"